import request from '@/utils/request';
export const defaultOrdersTransactionData = {
  id: 0,
  orderId: undefined,
  ordersDispatchId: undefined,
  transactionId: undefined,
  amountReceived: 0,
  order: {
    id: null
  },
  ordersDispatch: {
    id: undefined
  },
  transaction: {
    id: undefined
  }
};
export const getOrdersTransactions = params => request({
  url: '/orders-transactions',
  method: 'get',
  params
});
export const getOrdersTransactionById = id => request({
  url: `/orders-transactions/${id}`,
  method: 'get'
});